import Contratos from './Contratos';

export default Contratos;
